const MOBILE_MQ = '(max-width: 749px)';

let cleanup = () => {};

function isMobile() {
  return window.matchMedia(MOBILE_MQ).matches;
}

function visibleText(node) {
  if (!node) return '';
  return Array.from(node.childNodes)
    .filter((child) => {
      if (child.nodeType === Node.TEXT_NODE) return true;
      if (!(child instanceof Element)) return false;
      return !child.classList.contains('visually-hidden') && !child.classList.contains('price__hidden');
    })
    .map((child) => child.textContent || '')
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function readPrice(priceRoot) {
  if (!priceRoot) return { current: '', compare: '' };

  const saleWrap = priceRoot.querySelector('.price__sale:not(.price__hidden)');
  if (saleWrap) {
    return {
      current: visibleText(saleWrap.querySelector('.price-item--sale, .price')),
      compare: visibleText(saleWrap.querySelector('.compare-at-price')),
    };
  }

  const regularWrap = priceRoot.querySelector('.price__regular:not(.price__hidden)');
  if (regularWrap) {
    return { current: visibleText(regularWrap.querySelector('.price')), compare: '' };
  }

  return { current: visibleText(priceRoot.querySelector('.price')), compare: '' };
}

function initPdpMobileGallery() {
  cleanup();

  const media = document.querySelector('.product-information .product-information__media');
  const grid = media && media.querySelector('media-gallery.media-gallery--grid .media-gallery__grid');
  const details = document.querySelector('.product-information .product-details');
  const items = grid ? Array.from(grid.querySelectorAll('.product-media-container')) : [];

  document.querySelectorAll('.pdp-gallery-dots, .pdp-mobile-sheet').forEach((el) => el.remove());
  document.body.classList.remove('pdp-mobile-sheet-open');

  if (!media || !grid || !details || !isMobile() || items.length < 2) return;

  const lastItem = items[items.length - 1];
  const titleSource = details.querySelector('h1, .text-block.h1, [data-testid="product-title"]');
  const catchSource = details.querySelector('.product-catch-line:not(.product-catch-line--placeholder)');
  const priceSource = details.querySelector('product-price, .price');
  const cartButton =
    details.querySelector('.add-to-cart-button, product-form-component button[type="submit"], button[name="add"]') ||
    document.querySelector('.product-details .add-to-cart-button');

  const dots = document.createElement('div');
  dots.className = 'pdp-gallery-dots';
  dots.setAttribute('role', 'tablist');
  dots.setAttribute('aria-label', 'Product images');
  items.forEach((_, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pdp-gallery-dots__dot';
    button.dataset.index = String(index);
    button.setAttribute('aria-label', 'Go to image ' + (index + 1));
    if (index === 0) button.classList.add('is-active');
    dots.appendChild(button);
  });

  const sheet = document.createElement('div');
  sheet.className = 'pdp-mobile-sheet';
  sheet.innerHTML =
    '<div class="pdp-mobile-sheet__handle"></div>' +
    '<p class="pdp-mobile-sheet__catch" hidden></p>' +
    '<p class="pdp-mobile-sheet__title"></p>' +
    '<div class="pdp-mobile-sheet__price"></div>' +
    '<button type="button" class="pdp-mobile-sheet__cta button"></button>';

  const catchEl = sheet.querySelector('.pdp-mobile-sheet__catch');
  const titleEl = sheet.querySelector('.pdp-mobile-sheet__title');
  const priceEl = sheet.querySelector('.pdp-mobile-sheet__price');
  const ctaEl = sheet.querySelector('.pdp-mobile-sheet__cta');

  const syncSheet = () => {
    const catchText = catchSource && catchSource.textContent.trim();
    catchEl.hidden = !catchText;
    catchEl.textContent = catchText || '';
    titleEl.textContent = (titleSource && titleSource.textContent.trim()) || document.title;
    const price = readPrice(priceSource);
    priceEl.replaceChildren();
    if (price.current) {
      const current = document.createElement('span');
      current.className = 'pdp-mobile-sheet__price-current';
      current.textContent = price.current;
      priceEl.appendChild(current);
    }
    if (price.compare && price.compare !== price.current) {
      const compare = document.createElement('s');
      compare.className = 'pdp-mobile-sheet__price-compare';
      compare.textContent = price.compare;
      priceEl.appendChild(compare);
    }
    const ctaLabel = cartButton && cartButton.querySelector('.add-to-cart-text__content, .add-to-cart-text');
    ctaEl.textContent =
      (ctaLabel && visibleText(ctaLabel)) ||
      (cartButton && cartButton.getAttribute('aria-label')) ||
      'Add to cart';
  };
  syncSheet();

  document.body.append(dots, sheet);

  const setActiveDot = (index) => {
    dots.querySelectorAll('.pdp-gallery-dots__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  };

  const updateChrome = () => {
    const galleryVisible = items.some((item) => {
      const rect = item.getBoundingClientRect();
      return rect.bottom > 80 && rect.top < window.innerHeight;
    });
    const lastBottom = lastItem.getBoundingClientRect().bottom;
    const sheetHeight = sheet.offsetHeight || 180;
    const galleryStillActive = lastBottom > window.innerHeight - sheetHeight + 32;

    dots.classList.toggle('is-visible', galleryVisible && galleryStillActive);
    sheet.classList.toggle('is-visible', galleryStillActive);
    document.body.classList.toggle('pdp-mobile-sheet-open', galleryStillActive);
  };

  const onScrollOrResize = () => {
    let bestIndex = 0;
    let bestRatio = 0;
    items.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const visible = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      const ratio = visible / Math.max(rect.height, 1);
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestIndex = index;
      }
    });
    if (bestRatio > 0.15) setActiveDot(bestIndex);
    updateChrome();
  };

  dots.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.pdp-gallery-dots__dot') : null;
    if (!button) return;
    const item = items[Number(button.dataset.index)];
    if (!item) return;
    const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
    const top = item.getBoundingClientRect().top + window.scrollY - header;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });

  ctaEl.addEventListener('click', () => {
    const needsSize = document.body.classList.contains('pdp-awaiting-size') || (cartButton && cartButton.disabled);
    if (needsSize) {
      const sizePicker = document.querySelector('.product-information variant-picker');
      const sizeTarget = sizePicker && (sizePicker.querySelector('fieldset') || sizePicker);
      if (!sizeTarget) return;
      const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
      const top = sizeTarget.getBoundingClientRect().top + window.scrollY - header - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      sizePicker.classList.add('is-size-prompt');
      window.setTimeout(() => sizePicker.classList.remove('is-size-prompt'), 1600);
      const firstSize = sizePicker.querySelector('input[type="radio"]');
      if (firstSize) firstSize.focus({ preventScroll: true });
      return;
    }
    if (cartButton) cartButton.click();
  });

  const priceObserver = priceSource
    ? new MutationObserver(syncSheet)
    : null;
  if (priceSource && priceObserver) {
    priceObserver.observe(priceSource, { subtree: true, characterData: true, childList: true });
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  onScrollOrResize();

  cleanup = () => {
    window.removeEventListener('scroll', onScrollOrResize);
    window.removeEventListener('resize', onScrollOrResize);
    priceObserver?.disconnect();
    dots.remove();
    sheet.remove();
    document.body.classList.remove('pdp-mobile-sheet-open');
    cleanup = () => {};
  };
}

initPdpMobileGallery();
document.addEventListener('shopify:section:load', initPdpMobileGallery);

const mq = window.matchMedia(MOBILE_MQ);
if (mq.addEventListener) mq.addEventListener('change', initPdpMobileGallery);
else mq.addListener(initPdpMobileGallery);

const mediaRoot = document.querySelector('.product-information .product-information__media');
if (mediaRoot) {
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && node.matches && (node.matches('media-gallery') || node.querySelector('media-gallery'))) {
          initPdpMobileGallery();
          return;
        }
      }
    }
  }).observe(mediaRoot, { childList: true });
}
